export default __webpack_public_path__ + "static/media/27.ba373b1c.jpg";